// HeaderLogo.jsx
import tamerinLogo from '../assets/logo horizontal+descriptor - small.jpg';

const HeaderLogo = () => {
  const SHOW_HEADER =
    !window.location.search.includes('hide_header') ||
    process.env.REACT_APP_SHOW_HEADER === '1';

  if (!SHOW_HEADER) return null;

  return (
    <header className="flex w-full items-center p-3 sm:p-5 flex-wrap sm:flex-nowrap gap-2">
      {/* ── LONDI logo (left) ─────────────────────── */}
      <a
        href="https://londi.de/"
        target="_blank"
        rel="noreferrer"
        className="mr-2 sm:mr-4"
      >
        <img
          src="/images/LogoMakeOverFinal.png"
          alt="LONDI Logo"
          className="w-24 h-16 sm:w-36 sm:h-24 mx-1 sm:mx-2 lg:mx-5"
        />
      </a>

      {/* ── TamerinTECH credit (right) ────────────── */}
      <div className="ml-auto flex items-center gap-2">
        {/* hide the label on very small screens */}

        <a
          href="https://www.tamerin.tech"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 hover:opacity-80"
        >
          <img
            src={tamerinLogo}
            alt="Entwicklung: TamerinTECH GmbH Logo"
            className="h-10 sm:h-14 object-contain"
          />
        </a>
      </div>
    </header>
  );
};

export default HeaderLogo;
